(() => {
  document.querySelectorAll('[data-potion]').forEach(form => {
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:form.dataset.currency || 'USD'}).format(cents/100);
    const groups = [...form.querySelectorAll('fieldset')];
    const button = form.querySelector('[data-potion-submit]');
    const status = form.querySelector('[data-potion-status]');
    const preorderCutoff = new Date('2026-10-09T00:00:00-04:00').getTime();
    const earlyPreorder = Date.now() < preorderCutoff;
    let busy = false;
    function selection() { return groups.map(group => ({title:group.dataset.title,input:group.querySelector('input:checked')})); }
    function update() {
      const selections = selection();
      const summary = form.querySelector('[data-potion-summary]');
      summary.replaceChildren();
      let total = 0, missing = false, unpriced = false;
      selections.forEach(({title,input}) => {
        const li=document.createElement('li');
        li.textContent=title+': '+(input ? input.value : 'Choose an option');
        summary.append(li);
        if (!input) missing=true;
        else { total+=Number(input.dataset.price); if(input.dataset.ready !== 'true') unpriced=true; }
      });
      form.querySelector('[data-potion-total]').textContent=(unpriced ? 'Preview total: ' : missing ? 'Selected total: ' : 'Your total: ')+money(total);
      const selectedBase=form.querySelector('[data-size-group] input:checked');
      const orderingOpen=form.dataset.open==='true';
      const hasBase=!!selectedBase?.dataset.baseVariant;
      button.disabled=busy || !orderingOpen || !hasBase || missing || unpriced;
      button.textContent=busy ? (earlyPreorder ? 'Adding your preorder…' : 'Adding your potion…') : !orderingOpen ? 'Preorders coming soon' : !hasBase ? 'Build Your Potion' : unpriced ? 'Option pricing coming soon' : missing ? 'Complete your choices' : earlyPreorder ? 'Preorder My Potion' : 'Add my potion to cart';
      return selections;
    }
    form.addEventListener('change',update);
    form.addEventListener('submit',async event => {
      event.preventDefault();
      update();
      if(button.disabled || !form.reportValidity())return;
      const selections=selection();
      const groupId='potion-'+Date.now()+'-'+Math.random().toString(36).slice(2,8);
      const properties={'Event':'Potion Night','_potion_group':groupId};
      if(earlyPreorder) properties['Order type']='Early access preorder';
      selections.forEach(({title,input})=>properties[title]=input.value);
      const handle=form.elements.tiktok.value.trim();
      if(handle)properties['TikTok handle']=handle;
      if(form.elements.custom_name.value.trim()) properties['Custom potion name']=form.elements.custom_name.value.trim();
      if(form.elements.intention_note.value.trim()) properties['Intention note']=form.elements.intention_note.value.trim();
      const items=[{id:form.querySelector('[data-size-group] input:checked').dataset.baseVariant,quantity:1,properties}];
      selections.forEach(({title,input})=>{if(input.dataset.variant)items.push({id:input.dataset.variant,quantity:1,properties:{'Potion option':title,'_potion_group':groupId}});});
      busy=true;update();status.textContent='';
      try {
        const response=await fetch(form.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description || 'Your potion could not be added. Check availability and try again.');
        window.location.assign(form.dataset.cartUrl);
      }catch(error){status.textContent=error.message;busy=false;update();}
    });
    update();
  });
})();
